import { render } from "./AddToHomeView.vue?vue&type=template&id=1068b777&scoped=true"
import script from "./AddToHomeView.vue?vue&type=script&lang=js"
export * from "./AddToHomeView.vue?vue&type=script&lang=js"

import "./AddToHomeView.vue?vue&type=style&index=0&id=1068b777&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1068b777"]])

export default __exports__